import { h, render, Component } from "preact";
import { translate } from "react-i18next";

let redirectURL;

const locale = {
  labelUsername: "Username",
  labelPassword: "Password",
  labelConfirm: "Confirm",
  labelEmail: "Email",
  labelRecovery: "Recovery Code",
  labelTwoFactor: "Two Factor Code",
  labelAuth: "Authentication Code",
  labelAge:
    'I am 13+ years old and I agree to the <a href="https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf" rel="noopener noreferrer" target="_blank">Terms of Service</a>.',
  labelSubscribe: "Send me Hi-Rez Studios news.",
  copyCantLogin: "Can't Login?",
  copyDivider: "or",
  copyServicesSignup: "Sign Up With:",
  copyServicesLogin: "Login With:",
  copyContactSupport: "If the above options were not able to assist you:",
  btnLogin: "Login",
  btnCreate: "Create",
  btnCreateFree: "Create A Free Account",
  btnSubmit: "Submit",
  btnGoogle: "Google",
  btnFacebook: "Facebook",
  btnBack: "Back",
  btnRecoverUsername: "Forgot Your Username?",
  btnRecoverPassword: "Forgot Your Password?",
  btnRecoverCode: "Use One Time Recovery Code",
  btnBackupEmail: "Use Backup Email to Login",
  btnContactSupport: "Contact Customer Support",
  smiteCopy: "Sign Up Now! Join 25+ Million Players Today",
  errorUsernameMissing: "A username is required to create an account.",
  panelCopyCantLogin:
    "There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.",
  panelCopyForgotUsername: "Enter in the email associated with your account to receive a reminder email.",
  panelCopyForgotPassword: "Enter in the email and username associated with your account to reset your password.",
  panelCopyRecoveryCode:
    "Enter in the username and one time recovery code (when you setup your two factor authentication) to login.",
  panelCopyBackupEmail:
    "Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.",
  panelCopyCreateGoogle:
    "A verified email address with Google is required to create an account. You will use your Google login to play.",
  panelCopyCreateFacebook:
    "A verified email address with Facebook is required to create an account. You will use your Facebook login to play.",
  panelCopyLoginThirdParty: "You will be logged in as:",
  forgotResponse: "Thank you, an email has been sent to the address on file.",
  noMasterAccount: "We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?",
};

// Navigation Component
// TODO: cleanup state, switch, and general display of nav elements
// TODO: split nav elements off into containers and display with css based upon panel
// TODO: login with facebook, login with google, create with google, create with facebook views and routes
class Navigation extends Component {
  navController = (panel) => {
    switch (panel) {
      case "login":
        this.setState({ serviceHeaderCopy: locale.copyServicesLogin });
        this.setState({ showBackBtn: false });
        this.setState({ lastPanel: null });
        break;
      case "create":
        this.setState({ serviceHeaderCopy: locale.copyServicesSignup });
        this.setState({ showBackBtn: false });
        this.setState({ lastPanel: null });
        break;
      case "cant-login":
        this.setState({ showBackBtn: true });
        this.setState({ lastPanel: "login" });
        break;
      case "forgot-username":
        this.setState({ showBackBtn: true });
        this.setState({ lastPanel: "cant-login" });
        break;
      case "forgot-password":
        this.setState({ showBackBtn: true });
        this.setState({ lastPanel: "cant-login" });
        break;
      case "recovery-code":
        this.setState({ showBackBtn: true });
        this.setState({ lastPanel: "cant-login" });
        break;
      case "backup-email":
        this.setState({ showBackBtn: true });
        this.setState({ lastPanel: "cant-login" });
        break;
      case "create-google":
        this.setState({ showBackBtn: true });
        this.setState({ lastPanel: "create" });
        break;
      case "create-facebook":
        this.setState({ showBackBtn: true });
        this.setState({ lastPanel: "create" });
        break;
      case "login-google":
        this.setState({ showBackBtn: true });
        this.setState({ lastPanel: "login" });
        break;
      case "login-facebook":
        this.setState({ showBackBtn: true });
        this.setState({ lastPanel: "login" });
        break;
      default:
    }
  };

  loginWithGoogle = (response) => {
    if (response) {
      if (response.hasOwnProperty("error")) {
        // error handling
      } else {
        this.props.thirdParty("Google", response.accessToken, response.w3.U3, response.w3.Eea);
        this.props.callback("login-google");
        //token, email, id
      }
    }
  };

  createWithGoogle = (response) => {
    if (response.hasOwnProperty("error")) {
      // error handling
    } else {
      this.props.thirdParty("Google", response.accessToken, response.w3.U3, response.w3.Eea);
      this.props.callback("create-google");
      //token, email, id
    }
  };

  failedWithGoogle = (response) => {
    console.log(response);
  };

  loginWithFacebook = (response) => {
    if (response.hasOwnProperty("error")) {
      // error handling
    } else {
      this.props.thirdParty("Facebook", response.accessToken, response.email, response.id);
      this.props.callback("login-facebook");
      //token, email, id
    }
  };

  createWithFacebook = (response) => {
    if (response.hasOwnProperty("error")) {
      // error handling
    } else {
      this.props.thirdParty("Facebook", response.accessToken, response.email, response.id);
      this.props.callback("create-facebook");
      //token, email, id
    }
  };

  failedWithFacebook = (response) => {
    console.log(response);
  };

  constructor(props) {
    super(props);
    this.state = {
      panel: this.props.panel,
      lastPanel: null,
      showBackBtn: false,
      serviceHeaderCopy: null,
    };
  }

  componentWillMount() {
    this.navController(this.state.panel);
    // redirectURL = window.location.origin + window.location.pathname;
    redirectURL = "https://my.hirezstudios.com/";
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ panel: nextProps.panel });
    this.setState({ lastPanel: nextProps.lastPanel });
    this.navController(this.state.panel);
  }

  render() {
    const { t } = this.props;
    return (
      <div className="nav-wrapper">
        {this.state.panel === "login" && (
          <div className="nav-header">
            <div className="divider">{t(locale.copyDivider)}</div>
          </div>
        )}
        <div className={`services-container login ${this.state.panel === "login" ? "" : "is-disabled"}`}>
          <div className="third-party-services">
            <a href={`https://api.hirezstudios.com/oauth/out/facebook?url=${redirectURL}`}>
              <i className="icon-facebook" />
            </a>
            <a href={`https://api.hirezstudios.com/oauth/out/google?url=${redirectURL}`}>
              <i className="icon-google" />
            </a>
            <a href={`https://api.hirezstudios.com/oauth/out/discord?url=${redirectURL}`}>
              <i className="icon-discord" />
            </a>
            <a href={`https://api.hirezstudios.com/oauth/out/nintendo?url=${redirectURL}`}>
              <i className="icon-nintendo" />
            </a>
            <a href={`https://api.hirezstudios.com/oauth/out/playstation?url=${redirectURL}`}>
              <i className="icon-playstation" />
            </a>
            <a href={`https://api.hirezstudios.com/oauth/out/steam?url=${redirectURL}`}>
              <i className="icon-steam" />
            </a>
            <a href={`https://api.hirezstudios.com/oauth/out/xbox?url=${redirectURL}`}>
              <i className="icon-xbox" />
            </a>
          </div>
        </div>
        <div className={`services-container create ${this.state.panel === "create" ? "" : "is-disabled"}`}>
          <a className="back-to-login" onClick={() => this.props.callback("login", this.state.panel)}>
            {t("Already have a Hi-Rez Studios account? Login.")}
          </a>
        </div>
        <div className={`back-wrapper ${this.state.showBackBtn === true ? "" : "is-disabled"}`}>
          <a className="back-btn" onClick={() => this.props.callback(this.state.lastPanel)}>
            {t(locale.btnBack)}
          </a>
        </div>
      </div>
    );
  }
}

export default translate(["common"], { withRef: true })(Navigation);



// WEBPACK FOOTER //
// ./components/LoginPanelNavigation.js